import { render, staticRenderFns } from "./Paginator.vue?vue&type=template&id=a881d1c8&scoped=true"
import script from "./Paginator.vue?vue&type=script&lang=ts"
export * from "./Paginator.vue?vue&type=script&lang=ts"
import style0 from "./Paginator.vue?vue&type=style&index=0&id=a881d1c8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a881d1c8",
  null
  
)

export default component.exports